/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ReportingCode {
  id?: number;
  environment?: string;
  code?: string;
  description?: string;
  slackChannel?: string;
}
